import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Terms from '../tabs_sections/Terms';
import Privacy from '../tabs_sections/Privacy';
import Cookies from '../tabs_sections/Cookies';
import { useParams } from 'react-router-dom';
import { isMobile } from 'react-device-detect';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      <Box p={5} padding="0 40px">
        {children}
      </Box>
    </Typography>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `scrollable-auto-tab-${index}`,
    'aria-controls': `scrollable-auto-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  appBar: {
    backgroundColor: 'white',
    boxShadow: 'none',
  },
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    maxWidth: 904,
    margin: 'auto',
  },
  tabStyle: {
    maxWidth: 168,
    minWidth: '20%',
    height: 66,
    padding: '0 12px',
    fontSize: 16,
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    textAlign: 'center',
    textTransform: 'none',
    borderBottom: '1px solid #e7e7e7',
    '&$selected': {
      color: '#013957',
    },
    '@media (max-width: 424px)': {
      width: 140,
    },
  },
  selected: {},
  textColorPrimary: {
    color: '#c1c1c1',
  },
  indicator: {
    height: 2,
    backgroundColor: '#013957',
  },
  tabsContainer: {
    width: 'fit-content',
    margin: 'auto',
  },
  scrollButtonsDesktop: {
    color: '#013957',
    display: 'none',
    '@media (max-width: 890px)': {
      display: 'inherit',
    },
    '&>svg': {
      fontSize: 24,
    },
  },
  panel: {
    position: 'relative',
  },
}));

export default function ScrollableTabsButtonAuto() {
  const classes = useStyles();
  const { section } = useParams();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    switch (section) {
      case 'terminos-y-condiciones':
        setValue(0);
        break;
      case 'aviso-de-privacidad':
        setValue(1);
        break;
      case 'politicas-de-cookies':
        setValue(2);
        break;
      default:
        setValue(0);
        break;
    }
  }, []);

  return (
    <div className={classes.root}>
      <AppBar className={classes.appBar} position="static" color="default">
        <Tabs
          value={value}
          onChange={handleChange}
          textColor="primary"
          variant="scrollable"
          scrollButtons="auto"
          aria-label="full width tabs example"
          classes={{
            indicator: classes.indicator,
            flexContainer: classes.tabsContainer,
            scrollButtonsDesktop: classes.scrollButtonsDesktop,
          }}
        >
          <Tab
            classes={{
              root: classes.tabStyle,
              selected: classes.selected,
              textColorPrimary: classes.textColorPrimary,
            }}
            label="Términos y condiciones"
            {...a11yProps(0)}
          />
          <Tab
            classes={{
              root: classes.tabStyle,
              selected: classes.selected,
              textColorPrimary: classes.textColorPrimary,
            }}
            label="Avisos de privacidad"
            {...a11yProps(1)}
          />
          <Tab
            classes={{
              root: classes.tabStyle,
              selected: classes.selected,
              textColorPrimary: classes.textColorPrimary,
            }}
            label="Política de cookies"
            {...a11yProps(2)}
          />
        </Tabs>
      </AppBar>
      <TabPanel className={classes.panel} value={value} index={0}>
        <Terms />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <Privacy />
      </TabPanel>
      <TabPanel value={value} index={2}>
        <Cookies />
      </TabPanel>
    </div>
  );
}
